/*! cookie-expiration-date.js */

import Utils from "./utils";

const NINETY_DAYS_IN_MILLISECONDS = 1000 * 60 * 60 * 24 * 90;

function isValidDate(date) {
    return Utils.isDate(date) && !isNaN(date.getTime());
}

function getDateAndValidate(expiresInMilliseconds) {
    expiresInMilliseconds = expiresInMilliseconds || NINETY_DAYS_IN_MILLISECONDS;

    const date = new Date();
    date.setTime(date.getTime() + expiresInMilliseconds);

    if (date && !isValidDate(date)) {
        throw new Error("Invalid expires parameter");
    }

    return date;
}

const CookieExpirationDate = {

    stringInGMT(expiresInMilliseconds) {
        const date = getDateAndValidate(expiresInMilliseconds);
        return date.toGMTString();
    },

    totalMilliseconds(expiresInMilliseconds) {
        const date = getDateAndValidate(expiresInMilliseconds);
        return date.getTime();
    }
};

export default CookieExpirationDate;
